import React, { FunctionComponent, useCallback, useState } from 'react';
import { useRobloxAuthentication } from '@rbx/auth';
import { AuthenticationStatusV2 } from '../../topNavigation/components/AuthenticationStatus';

type TAuthenticationStatusContainer = {
  creatorHubUrl: string;
};

const AuthenticationStatusContainer: FunctionComponent<TAuthenticationStatusContainer> = ({
  creatorHubUrl,
}) => {
  const { login, logout, user, isFetched: isUserFetched } = useRobloxAuthentication();

  const [isLogoutInProgress, setIsLogoutInProgress] = useState<boolean>(false);

  const onLogout = useCallback(async () => {
    setIsLogoutInProgress(true);
    try {
      await logout();
    } finally {
      setIsLogoutInProgress(false);
    }
  }, [logout]);

  return (
    <AuthenticationStatusV2
      user={user}
      loading={!isUserFetched || isLogoutInProgress}
      onLogout={onLogout}
      onLogin={login}
      settingsHref={`${creatorHubUrl}settings/preferences`}
    />
  );
};

export default AuthenticationStatusContainer;
